import { ProductNameToIdMap } from "src/constants/ProductIds";
import { Company, FolderNode, Product, ReturnNode } from "src/types";

/**
 * Generates a unique key based on return node, product, and company.
 * @param {Object} returnNode - The return node object.
 * @param {Object} product - The product object.
 * @param {Object} company - The company object.
 * @return {string} A formatted unique key.
 */
export function generateUniqueKey(
    folderNode: FolderNode,
    returnNode: ReturnNode,
    product: Product,
    company: Company,
    state: string | null = null,
    quarter: string | null = null,
): string {
    // Generate unique key logic here
    let key = `${folderNode?.attributes?.displayName}-${returnNode?.id}-${returnNode?.displayName}-${product?.productName}-${product?.taxYear}-${company?.name}`;

    if (product.productId === ProductNameToIdMap.get("Municipal")) {
        // Append state and quarter if they are provided
        if (state !== null) {
            key += `_${state}`;
        }
        if (quarter !== null) {
            key += `_${quarter}`;
        }
    }
    return key;
}
